import { API_PATH } from '@api/path/path';
import { createHandler, sleep } from '../utils';
import { mockDB } from './../db/index';

export const getSpace = () =>
  createHandler(
    API_PATH.DAO.findCreatedSpaceByUserId,
    async (req, res, ctx) => {
      await sleep(200);
      return res(ctx.status(200), ctx.json(mockDB.vote.space.get()));
    },
  );

export const updateSpace = () =>
  createHandler(API_PATH.DAO.updateSpace, async (req, res, ctx) => {
    await sleep(200);
    return res(ctx.status(200), ctx.json({ id: mockDB.vote.space.get().id }));
  });

export const getVoteList = () =>
  createHandler(API_PATH.DAO.findVotes, async (req, res, ctx) => {
    const requestPageNumber =
      Number(req.url.searchParams.get('requestPageNumber')) || 1;
    const limit = Number(req.url.searchParams.get('limit')) || 8;
    const status = req.url.searchParams.get('status');
    const search = req.url.searchParams.get('search');

    mockDB.vote.voteListData.set({ limit, status, search });
    await sleep(200);
    return res(
      ctx.status(200),
      ctx.json(mockDB.vote.voteListData.get({ requestPageNumber })),
    );
  });

export const createVote = () =>
  createHandler(API_PATH.DAO.createVote, async (req, res, ctx) => {
    await sleep(200);
    return res(ctx.status(200), ctx.json({ id: mockDB.vote.space.get().id }));
  });

export const getVoteDetailInfo = () =>
  createHandler(API_PATH.DAO.findVoteById, async (req, res, ctx) => {
    const { voteId } = req.params;

    await sleep(200);
    return res(
      ctx.status(200),
      ctx.json(mockDB.vote.voteListData.getById({ voteId })),
    );
  });

export const getVoteDetailStatistics = () =>
  createHandler(API_PATH.DAO.findStatisticsById, async (req, res, ctx) => {
    const { voteId } = req.params;

    await sleep(200);
    return res(
      ctx.status(200),
      ctx.json({
        voteId,
        answers: mockDB.vote.voteResponseData.getStatistics(),
      }),
    );
  });

export const getVoteResponseList = () =>
  createHandler(API_PATH.DAO.findProgressById, async (req, res, ctx) => {
    const requestPageNumber =
      Number(req.url.searchParams.get('requestPageNumber')) || 1;
    const limit = Number(req.url.searchParams.get('limit')) || 8;
    const status = req.url.searchParams.get('sortField');
    mockDB.vote.voteResponseData.set({ limit, status });
    await sleep(200);
    return res(
      ctx.status(200),
      ctx.json(mockDB.vote.voteResponseData.get({ requestPageNumber })),
    );
  });

export const deleteVote = () =>
  createHandler(API_PATH.DAO.deleteVote, async (req, res, ctx) => {
    await sleep(200);
    return res(ctx.status(200), ctx.json({ successCount: 1 }));
  });

export const getVoteStatisticsForDashboard = () =>
  createHandler(API_PATH.DAO.findVoteStatistics, async (req, res, ctx) => {
    await sleep(200);
    return res(
      ctx.status(200),
      ctx.json(mockDB.vote.voteResponseData.getStatisticsForDashboard()),
    );
  });

export const getUserVotePaticipationsList = () =>
  createHandler(API_PATH.DAO.findVoteParticipations, async (req, res, ctx) => {
    const requestPageNumber =
      Number(req.url.searchParams.get('requestPageNumber')) || 1;
    const limit = Number(req.url.searchParams.get('limit')) || 5;

    mockDB.vote.voteResponseData.set({ limit });
    await sleep(200);
    return res(
      ctx.status(200),
      ctx.json(mockDB.vote.voteResponseData.get({ requestPageNumber })),
    );
  });

export default [
  getSpace(),
  updateSpace(),
  getVoteList(),
  createVote(),
  getVoteDetailInfo(),
  getVoteDetailStatistics(),
  getVoteResponseList(),
  deleteVote(),
  getVoteStatisticsForDashboard(),
  getUserVotePaticipationsList(),
];
